import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';

@Component({
    selector: 'app-common-modal',
    templateUrl: './common-modal.component.html',
    styleUrls: ['./common-modal.component.scss'],
    standalone: false
})
export class CommonModalComponent implements OnInit {
  @Input() vesselId: any;
  @Input() vessel: any;
  vesselForm: FormGroup;
  @Output() outputEvent = new EventEmitter();
  @Output() onUpdate = new EventEmitter();
 
  constructor(
    private readonly fb: FormBuilder,
    public readonly   activeModal: NgbActiveModal
  ) {}

  ngOnInit(): void {
    this.vesselForm = this.fb.group({
      vesselName: ['', Validators.required],
      callSign: ['', Validators.required],
      imoNumber: ['', Validators.required],
    });
  }

  close(value: boolean) {
    if (value) {
      this.onUpdate.emit(value);
    }
    this.activeModal.close(value);
  }

}
